PF.Entity.Array = class EntityArray extends Array {
    static get options() {
        return {
            dom: {},
            eventsTrait: PF.Entity.EventsTrait,
            populateOptions: true,
        };
    }

    constructor(options = {}, array = []) {
        if (options instanceof Object) {
            super(...array);
            PF.Options.populate(this, options);
            this.useTrait(this.eventsTrait);

            this.size = 0;
            this.recreate(array);
            this.init();
        } else {
            super(...arguments);
        }
    }

    init() {}

    useTrait(trait, use = true) {
        PF.H.useTrait(this, trait, use);
    }

    destroy() {
        this.off();
        for (let i = 0; i < this.length; i++) {
            this[i].destroy();
        }
        this.dom.destroy();
    }

    recreate(array) {
        this.splice(0, this.length, ...array);
    }

    pop() {
        let item = super.pop();
        this.trigger('removeOne', item);
        this.trigger('remove', [item]);
        item.destroy();
        this.trigger('modify', { removedItems: [item], addedItems: [] });
        this.size = this.length;
    }

    push(item) {
        super.push(item);
        this.trigger('addOne', item);
        this.trigger('add', [item]);
        this.trigger('modify', { removedItems: [], addedItems: [item] });
        this.size = this.length;
    }

    removeItem(item) {
        let index = this.indexOf(item);
        this[index].destroy();
        this.splice(index, 1);
    }

    shift() {
        let item = super.shift();
        this.trigger('removeOne', item);
        this.trigger('remove', [item]);
        this.trigger('modify', { removedItems: [item], addedItems: [] });
        this.size = this.length;
    }

    splice(start, deleteCount, ...addedItems) {
        for (let i = start; i < start + deleteCount; i++) {
            this[i].destroy();
        }
        let removedItems = super.splice(start, deleteCount, ...addedItems);
        for (let i = 0; i < addedItems.length; i++) {
            this.trigger('addOne', addedItems[i]);
        }
        for (let i = 0; i < removedItems.length; i++) {
            this.trigger('removeOne', removedItems[i]);
        }
        if (addedItems.length > 0) {
            this.trigger('add', addedItems);
        }
        if (removedItems.length > 0) {
            this.trigger('remove', removedItems);
        }
        this.trigger('modify', { removedItems: removedItems, addedItems: addedItems });
        this.size = this.length;
    }

    unshift(...addedItems) {
        super.unshift(...addedItems);
        for (let i = 0; i < addedItems.length; i++) {
            this.trigger('addOne', addedItems[i]);
        }
        this.trigger('add', addedItems);
        this.trigger('modify', { removedItems: [], addedItems: addedItems });
        this.size = this.length;
    }

    toJSON() {
        let result = [];
        for (let i = 0; i < this.length; i++) {
            if (this[i] instanceof PF.Model) {
                result.push(this[i].toJSON());
            } else {
                result.push(this[i]);
            }
        }
        return result;
    }

    linerize(field) {
        let result = [];
        if (typeof field === 'string') {
            for (let i = 0; i < this.length; i++) {
                result.push(PF.H.get(this[i], field));
            }
        }
        if (typeof field === 'function') {
            for (let i = 0; i < this.length; i++) {
                result.push(field(this[i]));
            }
        }
        return result;
    }

};